import { connect } from 'react-redux';

import IPManagementComponent from './IPManagementComponent';

import { SET_MODAL_TYPE } from '../../actionConstants';
import { deleteIP, loadIPList } from './actionCreators';

import { CONFIRM } from '../Modal/modalTypes';

const IPManagementContainer = (props) => <IPManagementComponent {...props} />;

const mapStateToProps = ({ ipManagement }) => ({
  ipsList: ipManagement,
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: (queryParams) => loadIPList(dispatch, queryParams),
  onDelete: (ip) => {
    const modalProps = {
      bodyText: `Are you sure you want to delete IP "${ip.name}"?`,
      onConfirm: () => deleteIP(dispatch, ip.id),
    };
    dispatch({
      type: SET_MODAL_TYPE,
      modalType: CONFIRM,
      modalProps,
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(IPManagementContainer);
